export default __webpack_public_path__ + "static/media/include_8_male@2x.868a8adc.jpg";